'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.controller('OrganizationsMap', ["$scope", function ($scope) {
	$scope.countries = organizationsMapData.countries;

	$scope.initTooltips = function () {
        ($scope.countries).forEach(element => {
			let countryEl = document.querySelector(`#${element.code}`);
			if(countryEl) {
				countryEl.setAttribute("data-tooltip-content", `#tooltip_content_${element.code}`);
				countryEl.setAttribute("tabindex", '0');
				countryEl.classList.add('map-tooltip', 'active');
			}
		});
		//$(window).on('load', function(){
			setTimeout(() => {
				$('.map-tooltip').tooltipster({
					delay: 15,
					position: 'bottom',
					theme: 'map-tooltip-theme',
					contentAsHTML: true,
					interactive: true,
					trigger: 'custom',
				});

				let isClickedTooltip = false;
				let isActiveTooltip = false
				$('body').on('mouseenter', '.map-tooltip', function(){
					if(!isActiveTooltip) {
						$(this).tooltipster('open');
						isActiveTooltip = true;
					}
				});
				$('body').on('click', '.map-tooltip', function(){
					if(isClickedTooltip) {
						$('.map-tooltip').tooltipster('close');
						isActiveTooltip = false;
					} else if(!isActiveTooltip && !isClickedTooltip){
						$(this).tooltipster('open');
						isActiveTooltip = true;
					}
					isClickedTooltip = !isClickedTooltip;
				});
				$('body').on('click', function(event){
					if(isClickedTooltip && isActiveTooltip) {
						let outsideClick = $(event.target).parents('.tooltipster-content').length == 0 && !$(event.target).hasClass('tooltipster-content');
						
						if(outsideClick && !$(event.target).hasClass('map-tooltip')) {
							$('.map-tooltip').tooltipster('close');
							isActiveTooltip = false;
							isClickedTooltip = !isClickedTooltip;
						}
					}
				});
				$('body').on('mouseleave', '.map-tooltip', function(event){
					if(!isClickedTooltip){
						$('.map-tooltip').tooltipster('close');
						isActiveTooltip = false;
						isClickedTooltip = false;
					}
				});
			}, "200");
			
		//});
    };
	$scope.initTooltips();
}]);